import React from 'react';
import styled from 'styled-components';

interface Props {
  error: unknown;
  className?: string;
}

const TextError: React.FC<React.PropsWithChildren<Props>> = ({
  error,
  className,
}) => {
  return error ? (
    <Wrapper className={className} data-test-id="ProdFac_TextError">
      {error as string}
    </Wrapper>
  ) : (
    <></>
  );
};

const Wrapper = styled.div`
  text-align: center;
  width: 100%;
  color: ${({ theme }) => theme.status.error};
  margin-bottom: 1.6rem;
`;

export default TextError;
